import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material/Chip';

export type StatusBadgeVariant =
  | 'approved'
  | 'pending'
  | 'under_review'
  | 'rejected'
  | 'suspended'
  | 'profile_incomplete';

const statusStyles: Record<StatusBadgeVariant, { bgcolor: string; color: string }> = {
  approved: { bgcolor: 'var(--success-bg)', color: 'var(--success-text)' },
  pending: { bgcolor: 'var(--gold-xlight)', color: 'var(--gold-dark)' },
  under_review: { bgcolor: 'var(--sage-light)', color: 'var(--sage-dark)' },
  rejected: { bgcolor: 'var(--error-bg)', color: 'var(--error-text)' },
  suspended: { bgcolor: 'var(--cream-warm)', color: 'var(--text-muted)' },
  profile_incomplete: { bgcolor: 'var(--cream-warm)', color: 'var(--text-muted)' },
};

type StatusBadgeProps = Omit<ChipProps, 'color'> & {
  status: StatusBadgeVariant;
  label: string;
};

export function StatusBadge({ status, label, sx, ...props }: StatusBadgeProps) {
  const style = statusStyles[status];
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        bgcolor: style.bgcolor,
        color: style.color,
        fontWeight: 700,
        fontSize: '0.6875rem',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        borderRadius: 'var(--radius-pill)',
        height: 'auto',
        py: 0.5,
        px: 0.5,
        ...sx,
      }}
      {...props}
    />
  );
}
